import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { purpurColorPurple50, purpurColorPurple100, purpurColorPurple800, } from '@purpurds/tokens/color/variables';
const ResultListButton = styled.button `
  background: inherit;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  padding: 2rem 24px;

  &:hover,
  &:focus {
    background-color: ${purpurColorPurple50};
    color: ${purpurColorPurple800};
  }

  &:active {
    background-color: ${purpurColorPurple100};
    color: ${purpurColorPurple800};
  }
`;
const CustomerInfo = styled.div `
  flex-grow: 1;
  text-align: left;
`;
const CustomerId = styled.div `
  padding-bottom: 0.2rem;
  font-weight: normal;
  letter-spacing: 2px;
`;
const FullName = styled.div `
  font-size: 1.4rem;
  font-weight: normal;
`;
const Address = styled.div `
  font-weight: normal;
  padding-top: 0.3rem;
`;
const CustomerStatus = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
`;
const Platforms = styled.div `
  font-weight: normal;
  padding-top: 0.3rem;
`;
export const SearchResultItem = ({ customer, onClick }) => (_jsxs(ResultListButton, { type: "button", onClick: () => onClick(), children: [_jsxs(CustomerInfo, { children: [_jsxs(CustomerId, { children: ["#", customer.customerId] }), _jsx(FullName, { children: `${customer.fullName}` }), _jsx(Address, { children: `${customer.street} ${customer.houseNumberNumeric}${customer.houseNumberAlpha}, ${customer.flatOrApartment}, ${customer.postalCode}, ${customer.bigCity}` }), _jsx(Platforms, { children: customer.platforms.join(' · ') })] }), _jsx(CustomerStatus, { children: _jsx("div", { children: `${customer.customerStatus}` }) })] }));
